__turbopack_context__.v({
  "aboutMeContainer": "RUCuKG_aboutMeContainer",
  "aboutMeHeading": "RUCuKG_aboutMeHeading",
  "agentBio": "RUCuKG_agentBio",
  "productItem": "RUCuKG_productItem",
  "productName": "RUCuKG_productName",
  "productsContainer": "RUCuKG_productsContainer",
  "productsHeading": "RUCuKG_productsHeading",
  "productsList": "RUCuKG_productsList",
});
